// https://owlcarousel2.github.io/OwlCarousel2/demos/demos.html
$('document').ready(function () {
  $('.carousel-default').owlCarousel({
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplaySpeed: 1000,
    autoplayHoverPause: true,
    margin: 20,
    navText: [" ", " "],
    dots: true,
    responsive: {
      0: {
        items: 2,
        nav: false,
        slideBy: 1,
      },
      576: {
        items: 4,
      },
      992: {
        items: 5,
      },
      2000: {
        items: 5,
      }
    }
  });

  $('.carousel-insights-testimonials').owlCarousel({
    loop: false,
    autoplay: false,
    autoplayTimeout: 3000,
    autoplaySpeed: 1000,
    autoplayHoverPause: true,
    margin: 20,
    navText: [" ", " "],
    dots: true,
    responsive: {
      0: {
        items: 1,
        nav: false,
        slideBy: 1,
      },
    }
  });


  $('.feat-services-carousel').owlCarousel({
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplaySpeed: 1000,
    autoplayHoverPause: false,
    margin: 20,
    dots: false,
    nav: false,
    //animateOut: 'fadeOut',
    responsive: {
      0: {
        items: 1,
      }
    }
  });

  $('.carousel-cases').owlCarousel({
    loop: false,
    autoplay: false,
    autoplayTimeout: 3000,
    autoplaySpeed: 1000,
    autoplayHoverPause: false,
    margin: 20,
    navText: [" ", " "],
    dots: true,
    responsive: {
      0: {
        items: 1,
        nav: false,
        navText: [" ", " "],
        stagePadding: 0,
      },
      500: {
        items: 2,
        stagePadding: 0,
      },
      992: {
        items: 3,
      },
      2000: {
        items: 3,
      }
    }
  });

  $('.carousel-posts').owlCarousel({
    loop: false,
    autoplay: false,
    dots: false,
    navText: [" ", " "],
    dots: true,
    margin: 32,
    responsive: {
      0: {
        items: 1,
        nav: false,
        navText: [" ", " "]
      },
      500: {
        items: 2,
      },
      992: {
        items: 3,
      },
      2000: {
        items: 3,
      }
    }
  });

  $('.carousel-testimonials').owlCarousel({
    loop: true,
    autoplay: false,
    //autoplayTimeout: 5000,
    //autoplaySpeed: 1000,
    //autoplayHoverPause: false,
    margin: 0,
    dots: true,
    items: 1,
    responsive: {
      0: {
        nav: false,
        navText: [" ", " "]
      },
      576: {
        nav: true,
      }
    }
  });


  let cols = $(".carousel-solutions-old .item").length;

  $('.carousel-solutions-old').owlCarousel({
    loop: false,
    autoplay: false,
    dots: false,
    margin: 0,
    stagePadding: 0,
    responsive: {
      0: {
        items: 1,
        nav: false,
        navText: [" ", " "],
        dots: true,
      },
      992: {
        items: cols,
      },
      2000: {
        items: cols,
      }
    }
  });

  $('.flex-carousel').each(function () {
    let cols = $(this).find('.item').length;

    $(this).owlCarousel({
      loop: false,
      autoplay: false,
      dots: false,
      margin: 0,
      stagePadding: 0,
      responsive: {
        0: {
          items: 1,
          nav: false,
          navText: [" ", " "],
          dots: true,
        },
        992: {
          items: cols,
        },
        2000: {
          items: cols,
        }
      }
    });
  });

  $('.milestone-carousel').owlCarousel({
    items: 1,
    loop: false,
    nav: true,
    center: true,
    margin: 20,
    responsiveClass: true,
    linked: ".years-carousel",
    animateOut: false,
    animateIn: false,
    mouseDrag: false,
    touchDrag: false
  });

  $(".years-carousel").owlCarousel({
    nav: true,
    loop: false,
    dots: false,
    responsiveClass: true,
    items: 6,
    margin: 0,
    center: true,
    responsive: {
      0: {
        items: 3,
        nav: false,
      },
      768: {
        items: 6,
        nav: false,
      }
    },
    linked: ".milestone-carousel"
  });

  $('.years-carousel').on('click', '.years a', function (e) {
    e.preventDefault();
    var order = $(this).data('order');
    $('.milestone-carousel').trigger('to.owl.carousel', [order, 300]);
  });

  if ($(window).scrollTop() > 160) {
    $('.header').addClass('sticky');
  }
  $(window).scroll(function () {
    let scroll = $(window).scrollTop();
    if (scroll > 160) {
      $('.header').addClass('sticky');
    } else {
      $('.header').removeClass('sticky');
    }
  });
});
